import { OverlayContainer } from '@angular/cdk/overlay';
import { Inject, Injectable, NgZone, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { EstensaBusWrapperService } from './angularjs/estensa-bus-wrapper.service';
import { SpecializedClientApplicationSettingsService } from './settings/specialized-client-application-settings.service';
import { DOCUMENT } from '@angular/common';

export enum Html5UITheme {
    Dark = 0,
    Light = 1,
}

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    // data members
    currentTheme: BehaviorSubject<string>;

    private readonly renderer: Renderer2;

    // constructor
    constructor(
        @Inject(DOCUMENT) private htmlDocument: Document,
        private specializedClientApplicationSettingsService: SpecializedClientApplicationSettingsService,
        private estensaBusWrapperService: EstensaBusWrapperService,
        private overlayContainer: OverlayContainer,
        private zone: NgZone,
        rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.currentTheme = new BehaviorSubject<string>('estensa-light');
        this.specializedClientApplicationSettingsService.getSettings().subscribe((settings) => {
            this.setCurrentTheme(settings.html5ClientUITheme);
        });

        this.estensaBusWrapperService.busDataFired.subscribe((busData) => {
            this.zone.run(() => {
                if (busData.messageType == 'UPDATE_THEME_MESSAGE') {
                    this.setCurrentTheme(busData.data == 'dark' ? Html5UITheme.Dark : Html5UITheme.Light);
                }
            });
        });
    }

    private setCurrentTheme(html5ClientUITheme: Html5UITheme) {
        const themeClassName = html5ClientUITheme == Html5UITheme.Light ? 'estensa-light' : 'estensa-dark';

        // rimuovo quello vecchio
        if (this.currentTheme.value == 'estensa-light') {
            this.overlayContainer.getContainerElement().classList.remove('estensa-light');
        } else {
            this.overlayContainer.getContainerElement().classList.remove('estensa-dark');
        }

        this.currentTheme.next(themeClassName);
        this.overlayContainer.getContainerElement().classList.add(themeClassName);

        this.htmlDocument.head.querySelectorAll('link[data-theme]').forEach((element) => {
            this.renderer.removeChild(this.htmlDocument.head, element);
        });

        const stylesheet = this.renderer.createElement('link') as HTMLLinkElement;
        this.renderer.setProperty(stylesheet, 'rel', 'stylesheet');
        this.renderer.setProperty(stylesheet, 'href', `grid-${themeClassName}.css`);
        this.renderer.setAttribute(stylesheet, 'data-theme', '');
        this.renderer.appendChild(this.htmlDocument.head, stylesheet);
    }

    public getTheme() {
        return this.currentTheme.asObservable();
    }

    public setTheme(html5ClientUITheme: Html5UITheme) {
        this.setCurrentTheme(html5ClientUITheme);
    }
}
